import React from 'react';
import { Link } from 'gatsby';

import CircleWithImage from '../components/CircleWithImage';

const ProductMainMenu = ({ menu = [] }) => {
    let colorName = 'first';
    let iconImage;
    let counterItem = 0;

    return (
        <div className="MenuLinksWithIconList">
            {menu.map((menuRow, i) => (
                <div className="MenuLinksWithIconList-Row" key={i}>
                    {menuRow.map((menuItem, j) => {
                        colorName = counterItem%2 === 0 ? 'first' : 'second';
                        counterItem = counterItem + 1;
                        iconImage = require("../images/icons/styled/" + colorName + "/" + menuItem.icon );

                        const menuLinkContent = (
                            <>
                                <CircleWithImage size="small" color={colorName}>
                                    <img src={iconImage} alt={menuItem.title} />
                                </CircleWithImage>

                                <span className="MenuLinkWithIcon-Text">{menuItem.title}</span>
                            </>
                        );

                        if (menuItem.href) {
                            return (
                                <a 
                                    className="MenuLinkWithIcon" 
                                    href={menuItem.href}
                                    key={j}
                                    target="_blank"
                                >
                                    {menuLinkContent}
                                </a>
                            )
                        }

                        return (
                            <Link 
                                className="MenuLinkWithIcon" 
                                to={menuItem.url} 
                                activeClassName="active" 
                                key={j}
                            >
                                {menuLinkContent}
                            </Link>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default ProductMainMenu;
